import httpManager from "@/app/shared/utils/httpManager";

export default async function (params) {
  let query = "?";
  query += params.entity ? `entity=${params.entity}&` : "";
  query += params.campaign ? `portfolio=${params.campaign}&` : "";
  query += params.base ? `base=${params.base}&` : "";
  query += params.timeStart ? `start_date=${params.timeStart}&` : "";
  query += params.timeEnd ? `end_date=${params.timeEnd}&` : "";
  query += params.user ? `user=${params.user}&` : "";
  const url = `/reports/3/download/${query}`;
  const response = await httpManager.post(url, {}, { blob: true });
  return response;
}
